import { PlatformEventState } from './types';

export const initialPlatformEventState: PlatformEventState = {
  platformEvents: [],
};
